import { gql } from '@apollo/client/core';

interface FormPublicFieldFragment {
  id: string;
  idx: number;
  title: string;
}

export interface SubmissionPublicFieldFragment {
  id: string;
  value: string;
  field: FormPublicFieldFragment;
}

export interface SubmissionPublicFragment {
  id: string;
  fields: SubmissionPublicFieldFragment[];
}

export const SUBMISSION_PUBLIC_FRAGMENT = gql`
  fragment PublicSubmission on Submission {
    id
    fields {
      id
      value
      field {
        id
        idx
        title
      }
    }
  }
`;
